import { Injectable } from '@angular/core';
import { Document } from '../../models/document';
import { Societe, Signataire } from '../../models/societe';
import { User } from '../../models/user';
import { createStore, Action, Store, Reducer } from 'redux';
import reducers from './reducers';

const INITIAL_STATE = [];

@Injectable()
export class StateService {

  state = INITIAL_STATE;


  public current_doc_id: number;
  public document: Document;
  public societe: Societe;
  public signataire: Signataire;
  public currentUser: User;

  constructor(
    
  ) {
    
  }

  setCurrentDoc(document: Document){
    this.document = document;
  }

  getCurrentDoc(){
    return this.document;
  }

  setCurrentSociete(societe: Societe){
    this.societe = societe;
  }

  getCurrentSociete(){
    return this.societe;
  }

  setCurrentSignataire(signataire: Signataire){
    this.signataire = signataire;
  }

  getCurrentSignataire(){
    return this.signataire;
  }

  setCurrentUser(currentuser: User){
    console.log(currentuser);
    this.currentUser = currentuser; 
  }

  getCurrentUser(){
    return this.currentUser;
  }

}

const store = createStore(reducers);

export default store;



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/services/state/state.service.ts